import { IDeploymentHistory, IPopulatedDeployment } from '@/modules/deployment/IDeployment';
import { Feature } from '@/modules/deployment/types/Feature';
import { ConfigurableStatus, Plan } from '@/modules/deployment/types/Plan';
import { FeatureStatus } from '@/modules/deployment/types/Enumarables';

export const DeploymentHelper = {
  data() {
    return {};
  },
  methods: {
    injectMauToDeployment(payload: { deployment: IPopulatedDeployment, history: IDeploymentHistory[][]}) {
      const mauInjectedDeployment = { ...payload.deployment, mau: {} };
      const targetSubs = payload?.history.filter((sub) => sub.some((point) => point.subscriptionId === payload.deployment.subscription._id));
      const lastSubMau = targetSubs.length ? targetSubs[0].map((point) => ({ value: point.used, startsAt: point.startsAt, endsAt: point.endsAt })) : [];
      mauInjectedDeployment.mau = { values: lastSubMau };

      return mauInjectedDeployment;
    },
    convertNumberToAbbreviated(num: number) {
      if (num >= 1000000) {
        return `${(num / 1000000).toFixed(0)}M`;
      } if (num >= 1000) {
        return `${(num / 1000).toFixed(0)}K`;
      }
      return num.toString();
    },
    extractMauFromPlanCode(planCode: string) {
      if (!planCode) {
        return 0;
      }

      // New v3 plan codes use the underscore format ("v3_mau_5_000_gcp_base").
      // The MAU is the `mau_<n>_000` token, e.g. v3_mau_5_000_gcp_base -> 5000,
      // v3_mau_1000_000_gcp_base -> 1000000.
      if (planCode.startsWith('v3_')) {
        const v3Match = planCode.toLowerCase().match(/mau_([\d_]+)/);
        if (!v3Match) {
          return 0;
        }
        const v3Mau = parseInt(v3Match[1].replaceAll('_', ''), 10);
        return Number.isNaN(v3Mau) ? 0 : v3Mau;
      }

      // Legacy dotted format ("v2.mau_5_000_mock_cloud.base") — unchanged behaviour.
      const withoutUnderscore = planCode.split('.')[1]?.replaceAll('_', '');
      const match = withoutUnderscore?.match(/(\d+)/);

      if (match) {
        return parseInt(match[1], 10);
      }

      return 0;
    },
    convertAbbreviatedToNumber(abbreviatedMau: string) {
      // example abbreviatedMau: 5K, 5M
      // example result: 5000, 5000000
      return parseInt(abbreviatedMau.replace('K', '000').replace('M', '000000'), 10);
    },
    convertMauToPlanCodeFormat(mau: number) {
      // example num: 5000
      // example result: 5_000
      return mau.toLocaleString().replace(/,/g, '_');
    },
    // we're start to look all upper plans from the current one
    // if we found the feature in the upper plan, we return the plan name
    // if we didn't find the feature in the upper plan, we return false
    getAvailableTier(feature: Feature, features: Feature[], plans: Plan[]): { availableForOtherTier: boolean, tier?: string } {
      let matchedPlan: Plan | undefined;

      const featureObj = features?.filter((f) => f.status === FeatureStatus.ACTIVE).find((f) => f.code === feature.code);

      if (!featureObj) {
        return {
          availableForOtherTier: false,
        };
      }

      const sortedPlans = [...plans].sort((a, b) => this.extractMauFromPlanCode(a.code) - this.extractMauFromPlanCode(b.code));

      sortedPlans.forEach((plan) => {
        if (typeof matchedPlan === 'undefined') {
          plan.features
            .filter((f) => f.status === ConfigurableStatus.AVAILABLE)
            .forEach((planFeature) => {
              if (typeof matchedPlan === 'undefined' && planFeature.refId === feature._id) {
                matchedPlan = plan;
              }
            });
        }
      });

      if (matchedPlan) {
        return {
          availableForOtherTier: true,
          tier: matchedPlan.name,
        };
      }

      return {
        availableForOtherTier: false,
      };
    },
  },
};
